import { FORMAT_PRESETS } from '@cinematic-engine/core';
import { buildSampleCompiledProject } from '../../samples/sample-project';
import { useStudio } from '../../store/studio-store';

export function ProjectPanel() {
  const project = useStudio((s) => s.project);
  const setProject = useStudio((s) => s.setProject);
  const selectedFormat = useStudio((s) => s.selectedFormat);
  const setFormat = useStudio((s) => s.setFormat);

  function loadSample() {
    const compiled = buildSampleCompiledProject();
    setProject(compiled);
    setFormat(FORMAT_PRESETS[compiled.format.preset] ?? null);
  }

  function clearProject() {
    setProject(null);
    setFormat(null);
  }

  return (
    <div className="panel">
      <div className="panel-header">
        <h2>Project</h2>
      </div>

      <section className="panel-section">
        <h3>Formats</h3>
        <div className="format-grid">
          {Object.values(FORMAT_PRESETS).map((preset) => (
            <button
              key={preset.id}
              type="button"
              className={`format-card${selectedFormat?.id === preset.id ? ' selected' : ''}`}
              onClick={() => setFormat(preset)}
            >
              <div className="format-name">{preset.name}</div>
              <div className="format-meta">
                {preset.aspectRatio.label} · {preset.defaultResolution.width}×
                {preset.defaultResolution.height} · {preset.fps}fps
              </div>
            </button>
          ))}
        </div>
      </section>

      <section className="panel-section">
        <h3>Actions</h3>
        <div className="action-row">
          <button type="button" className="primary-btn" onClick={loadSample}>
            Load Sample Project
          </button>
          <button type="button" className="ghost-btn" onClick={clearProject} disabled={!project}>
            Clear
          </button>
        </div>
      </section>

      {project && (
        <section className="panel-section">
          <h3>Loaded</h3>
          <dl className="kv-list">
            <dt>Title</dt>
            <dd>{project.metadata.title}</dd>
            <dt>Duration</dt>
            <dd>
              {project.durationSeconds.toFixed(2)}s ({project.durationFrames} frames)
            </dd>
            <dt>Shots</dt>
            <dd>{project.scenes.reduce((acc, s) => acc + s.shots.length, 0)}</dd>
            <dt>Style</dt>
            <dd>{project.style.preset}</dd>
          </dl>
        </section>
      )}
    </div>
  );
}
